<template>
  <div
    style="width: 100%; margin: 0px; margin-top: 2px; font-size: 11px;"
    class="small-text"
  >
    <v-card>
      <v-simple-table
        dense
        class="font-size-11"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Zone
              </th>
              <th class="text-left">
                Asap
              </th>
              <th class="text-left">
                15
              </th>
              <th class="text-left">
                30
              </th>
              <th class="text-left">
                1H
              </th>
              <th class="text-left">
                2H
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="zone in sortedZones"
            >
              <tr
                v-if="taxisForZone(zone.id).length > 0 || zone.id == (bookingForm && bookingForm.booking && bookingForm.booking.zone ? bookingForm.booking.zone.id : 0 ) || zone.id == (bookingForm && bookingForm.booking && bookingForm.booking.selected_taxi_zone_id ? bookingForm.booking.selected_taxi_zone_id : 0 )"
                :key="zone.id"
                :style="{ 'background': computeBackgroundStyle(zone.id) }"
              >
                <td>
                  {{ zone != null ? zone.name : '' }}
                </td>
                <td>
                  {{ asapBookings(zone.id) != 0 ? asapBookings(zone.id) : '' }}
                </td>
                <td>
                  {{ bookingsInXMinutes(zone.id, 0, 15) != 0 ? bookingsInXMinutes(zone.id, 0, 15) : '' }}
                </td>
                <td>
                  {{ bookingsInXMinutes(zone.id, 15, 30) != 0 ? bookingsInXMinutes(zone.id, 15, 30) : '' }}
                </td>
                <td>{{ bookingsInXMinutes(zone.id,30,60) != 0 ? bookingsInXMinutes(zone.id,30,60) : '' }}</td>
                <td>{{ bookingsInXMinutes(zone.id,60,120) != 0 ? bookingsInXMinutes(zone.id,60,120) : '' }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";
import moment from "moment";

export default {
  name: "BookingZonesSummary",
  components: {
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: {
      type: Array,
      default: null
    },
    bookings: {
      type: Array,
      default: null
    },
    zones: {
      type: Array,
      default: null
    },
    bookingForm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
    };
  },
  computed: {
    sortedZones () {
      if (!(this.bookingForm.booking && this.bookingForm.booking.zone)){
        return this.zones
      }
      let bookingZone = this.zones.find((z) => {
        return z.id == this.bookingForm.booking.zone.id
      })
      if (bookingZone) {
        const index = this.zones.map(e => e.id).indexOf(bookingZone.id);
        this.zones.splice(index, 1);
        this.zones.unshift(bookingZone)
      }
      if (this.bookingForm.booking.selected_taxi_zone_id != null) {
        let taxiZone = this.zones.find((z) => {
          return z.id == this.bookingForm.booking.selected_taxi_zone_id
        })
        console.log('taxi zone id is set')
        if (taxiZone) {
          console.log('taxi zone found ', taxiZone)
          const taxiZoneIndex = this.zones.map(e => e.id).indexOf(taxiZone.id);
          console.log('taxi zone index ', taxiZoneIndex)
          this.zones.splice(taxiZoneIndex, 1);
          this.zones.unshift(taxiZone)
        }
      }
      return this.zones
    },
    upcomingBookingsList () {
      if (this.bookings) {
        return this.bookings.filter (b => {
          return b.state == 'booked' && b.zone
        })
      }
      return []
    }
  },
  methods: {
    computeBackgroundStyle (zoneId) {
    if(zoneId == (this.bookingForm && this.bookingForm.booking && this.bookingForm.booking.zone ? this.bookingForm.booking.zone.id : 0 )) {
      return '#00ff00'
    }
    if(zoneId == (this.bookingForm && this.bookingForm.booking && this.bookingForm.booking.selected_taxi_zone_id ? this.bookingForm.booking.selected_taxi_zone_id : 0 )) {
      return '#608360'
    }
    return 'white'
    },
    taxisForZone: function(id) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(
          this.taxis,
          this.bookings,
          this.$store.state.use_zone_based_dispatch
      );

      return ow.sortTaxisByState(
          this.taxis.filter(function(t) {
            return t.zone == id;
          })
      );
    },
    upcomingBookings: function(zoneId) {
      var bf = this.bookingForm;

      if (!this.bookings || !this.bookings.length) {
        return []
      }
      return this.bookings.filter(function(b) {

        if (bf.booking.zone == null ) {
          return false;
        }

        return b.state == 'booked' && b.zone.id == zoneId;
      });
    },
    asapBookings: function(zoneId) {
      return this.upcomingBookingsList.filter(function(b) {
        return b.asap == true && b.zone.id == zoneId;
      }).length;
    },
    bookingsInXMinutes: function(zoneId, minMinutes, maxMinutes) {

      return this.upcomingBookingsList.filter(b => {
        return b.zone.id == zoneId
      }).filter(function(b) {
        var time = moment(b.pickup_timestamp);
        var duration =  - (moment().diff(time, 'minutes'));
        return (duration >= minMinutes && duration < maxMinutes);
      }).length
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

table { border-collapse: collapse; }
tr { border: none; }

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 11px;
}


.font-size-11  td,th {
  font-size: 11px !important;
}


</style>
